import { createFileRoute } from '@tanstack/react-router';

import { NotificationRulesSettingsPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/notifications')({
  component: NotificationRulesSettingsPage,
});
